/* __next_internal_client_entry_do_not_use__ HomeLogin auto */import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import google from "@/assets/image/google.png";
import styles from "./index.module.scss";
import { codeVerify, emailVerify, loginFormPost, passwordVerify, phoneVerify } from "../../util";
import { useUserCreate } from "@/store/User";
import { usePopups } from "@/store/popups";
// import logo from '@assets/image/user/Logo.png';
import logo from "@/assets/image/user/Logo.png";
import { SwitchBarForLogin } from "../../components/SwitchBar";
import { PhoneForm } from "./PhoneForm";
import { isMobileOnly } from "react-device-detect";
import classNames from "classnames";
import { BaseInput } from "@/components/common/BaseInputV2";
import { NewBaseButton } from "@/components/common/NewBaseButton";
import { openLink } from "@/handle/route";
import Image from "next/image";
import { NewBaseIcon } from "@/components/common/NewBaseIcon";
import { mail, lock, viewOff, view } from "@/assets/icons/svgV2";
import { useGlobalStore } from "@/store/globalStore";
import { useGoogleLogin } from "@/handle/login/google/useGoogleLogin";
import { useTranslations } from "next-intl";
const SWITCH_CONFIG = t => [{
  get name() {
    return t("Login_Phone_Tab");
  },
  key: "phone"
}, {
  get name() {
    return t("Login_Email_Tab");
  },
  key: "email"
}];
export const HomeLogin = props => {
  const {
    changeHandle,
    data,
    changeAccountData
  } = props;
  const [verifyPdText, setVerifyPdText] = useState("");
  const [verifyEmailText, setVerifyEmailText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [needVerify, setNeedVerify] = useState(false);
  const [pdHidden, setPdHidden] = useState(false);
  const t = useTranslations();
  const isInnerChina = useGlobalStore(state => state.isInChina);
  const [isShowPhone, setIsShowPhone] = useState(isInnerChina);
  const popupDispatch = usePopups(state => state.dispatch);
  const userDispatch = useUserCreate(state => state.dispatch);
  const handleGoogleLogin = useGoogleLogin({
    flow: "auth-code",
    ux_mode: "popup",
    // redirect_uri: `${A1_JS_URL}/authen`,
    state: "google"
  });
  const googleLogin = useCallback(async () => {
    handleGoogleLogin();
  }, [handleGoogleLogin]);
  const basicLoginHandle = async () => {
    setNeedVerify(true);
    if (!isShowPhone && (verifyPdText || verifyEmailText)) return;
    if (isShowPhone && (!phoneVerify(data.phone, t).isVerify || !codeVerify(data.p_code, t).isVerify)) return;
    setIsLoading(true);
    const params = isShowPhone ? {
      phone: data.phone,
      code: data.p_code
    } : {
      email: data.email,
      password: data.password
    };
    await loginFormPost(params, popupDispatch, isShowPhone ? "phone" : "email", userDispatch, () => {
      changeHandle("verify");
    }, props.onSucc);
    setIsLoading(false);
    // changeHandle('verify');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.title,
      children: [t("Login_Title"), " ", /*#__PURE__*/_jsx(Image, {
        src: logo,
        width: 64,
        alt: ""
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.form_body,
      children: [/*#__PURE__*/_jsxs(NewBaseButton, {
        size: "huge",
        className: styles.google_log,
        onClick: googleLogin,
        block: true,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.absoluteIcon,
          children: /*#__PURE__*/_jsx(Image, {
            src: google,
            width: 20,
            height: 20,
            alt: ""
          })
        }), t("Login_ContinueWithGoogle_Aciton")]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.line_gap
      }), isInnerChina && /*#__PURE__*/_jsx(SwitchBarForLogin, {
        config: SWITCH_CONFIG(t),
        checkoutFunc: key => {
          setIsShowPhone(!!(key === "phone"));
        }
      }), isShowPhone ? /*#__PURE__*/_jsx(PhoneForm, {
        needVerify: true,
        verifyTextType: "blur",
        changeAccountData: changeAccountData,
        data: data
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BaseInput, {
          value: data.email,
          onChange: e => {
            changeAccountData({
              email: e.target.value
            });
          },
          placeholder: t("Login_Email_Placeholder"),
          verifyText: needVerify ? verifyEmailText : "",
          verifyFn: v => {
            const {
              isVerify,
              verifyText
            } = emailVerify(v, t);
            setVerifyEmailText(verifyText);
            return needVerify ? isVerify : true;
          },
          maxLength: 40,
          prefix: /*#__PURE__*/_jsx(NewBaseIcon, {
            icon: mail,
            size: 20,
            color: "rgba(102, 112, 133, 1)"
          })
        }), /*#__PURE__*/_jsx(BaseInput, {
          value: data.password,
          onChange: e => {
            changeAccountData({
              password: e.target.value
            });
          },
          className: styles.password,
          placeholder: t("Login_Password_Placeholder"),
          verifyText: needVerify ? verifyPdText : "",
          verifyFn: v => {
            const {
              isVerify,
              verifyText
            } = passwordVerify(v, t);
            setVerifyPdText(verifyText);
            return needVerify ? isVerify : true;
          },
          maxLength: 40,
          type: pdHidden ? "text" : "password",
          prefix: /*#__PURE__*/_jsx(NewBaseIcon, {
            icon: lock,
            size: 20,
            className: styles.icon
          }),
          suffix: data.password ? /*#__PURE__*/_jsx(NewBaseIcon, {
            icon: pdHidden ? view : viewOff,
            size: 20,
            onClick: () => setPdHidden(pre => !pre),
            className: styles.view
          }) : /*#__PURE__*/_jsx(_Fragment, {})
        }), /*#__PURE__*/_jsx("span", {
          className: styles.forget_pd,
          onClick: () => {
            changeHandle("reset");
          },
          children: t("Login_ForgotPassword_Action")
        })]
      }), /*#__PURE__*/_jsx(NewBaseButton, {
        className: styles.logBtn,
        size: "large",
        preset: "secondary",
        // children="Log in / Sign up"
        loading: isLoading,
        onClick: basicLoginHandle,
        children: t("Login_LoginSignUp_Action")
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.tips, {
          [styles.isMobile]: isMobileOnly
        }),
        children: [/*#__PURE__*/_jsx("p", {
          children: t("SupportPolicy_AgreeText_Text")
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx("a", {
            onClick: () => {
              openLink("/privacy-terms");
            },
            children: t("SupportPolicy_ServicesTerm_Link")
          }), " ".concat(t("SupportPolicy_And_Text"), " "), /*#__PURE__*/_jsx("a", {
            onClick: () => {
              openLink("/privacy-policy");
            },
            children: t("SupportPolicy_PrivacyPolicy_Link")
          })]
        })]
      })]
    })]
  });
};